import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import LogoUrl from '../../../../resources/logo.svg';
import FullscreenIconUrl from '../../../../resources/icons/icon-fullscreen.svg';
import ToolsIconUrl from '../../../../resources/icons/icon-tools.svg';
import ZoomIconUrl from '../../../../resources/icons/icon-zoom.svg';
import DownloadIconUrl from '../../../../resources/icons/download-icon-white.svg';

import {
  WEBSITE_URL,
  MENU_HIERARCHY_MOBILE,
  MENU_MOBILE_FOOTER_HEIGHT,
  PDF_NAME_HR,
  DOWNLOAD_TEXT,
} from '../../../../config';

import styles from '../styles';
import parse from '../../../../utils/parse';
import { List } from '@mui/material';
import ShareButton from './ShareButton';

class MobileAppMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentHighlightedItem: null,
      swipeMenuOpen: false,
    };
  }
  /**
   * HANDLE
   */
  handleNavigate(page) {
    const { onNavigate } = this.props;
    this.setState({ swipeMenuOpen: false });
    onNavigate(page);
  }
  /**
   * RENDER
   */
  renderHeader() {
    const { classes, onToggleFullscreen, onZoom } = this.props;
    return (
      <AppBar
        className={classes.mobileMenuHeader}
        elevation={0}
        color="inherit"
        position="fixed"
      >
        <Toolbar disableGutters>
          <Stack sx={{ width: '100%', height: '100%' }} direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer">
              <img src={LogoUrl} alt="Agence Luciole" />
            </a>
            <Box sx={{ flex: 1 }}></Box>
            <Stack alignItems="center">
              <Stack direction="row">
                <IconButton onClick={() => onToggleFullscreen(true)}>
                  <img className={classes.menuIcon} src={FullscreenIconUrl} alt="Plein écran" />
                </IconButton>
                <IconButton onClick={() => onZoom()}>
                  <img className={classes.menuIcon} src={ZoomIconUrl} alt="Zoom" />
                </IconButton>
                <IconButton onClick={() => this.setState({ currentHighlightedItem: 'MENU', swipeMenuOpen: true })}>
                  <img className={classes.menuIcon} src={ToolsIconUrl} alt="Menu" />
                </IconButton>
              </Stack>
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
    );
  }

  renderFooter() {
    const { classes, page } = this.props;
    const { currentHighlightedItem, swipeMenuOpen } = this.state;

    const color = (currentHighlightedItem && currentHighlightedItem.color) || 'secondary';

    return (
      <div className={`${classes.mobileMenuFooter} ${swipeMenuOpen ? 'swipeMenuOpen' : ''} ${color}`}>
        <SwipeableDrawer
          anchor="bottom"
          open={swipeMenuOpen}
          onClose={() => this.setState({ swipeMenuOpen: false })}
          onOpen={() => { }}
          swipeAreaWidth={MENU_MOBILE_FOOTER_HEIGHT}
          disableSwipeToOpen
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            className: `${classes.mobileMenuSwipe} ${classes.subDrawer} ${color}`,
            elevation: 0,
          }}
        >
          <Paper
            className={classes.mobileMenuSwipePaper}
            elevation={0}
            sx={{ backgroundColor: currentHighlightedItem && currentHighlightedItem !== 'MENU' ? '' : `primary !important` }}
          >
            <Box className={classes.mobileMenuPuller} />
            {currentHighlightedItem && currentHighlightedItem !== 'MENU' ? (
              <>
                <List sx={{ overflowY: 'auto' }}>
                  {currentHighlightedItem.list.map(bookmark => {
                    const isFocus = page >= bookmark.pages[0] && page <= bookmark.pages[1];
                    return (
                      <ListItem sx={{ px: 4 }} key={bookmark.label} className={`${classes.subListItem} ${currentHighlightedItem.color} ${isFocus ? 'focus' : ''}`} disablePadding>
                        <ListItemButton sx={{ p: 0 }} onClick={() => this.handleNavigate(bookmark.pages[0])}>
                          <ListItemText
                            className={`${classes.subListItemLabel} ${currentHighlightedItem.color}`}
                            primary={
                              <>
                                <Typography variant="h4" component="p" color="primary.main" fontWeight={700} textAlign="center">{parse(bookmark.number)}</Typography>
                                <Typography variant="h4" color="primary.main" textAlign="center">{parse(bookmark.label)}</Typography>
                              </>
                            }
                            secondary={<span className={`listItemFocus ${currentHighlightedItem.color}`}></span>}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </>
            ) : (
              <>
                  <Stack sx={{ mb: 2, mt: 2 }} direction="column" justifyContent="center" alignItems="center" spacing={2}>
                    <ShareButton classes={classes} isMobile />
                    <ListItem key="download" className={classes.listItem} disablePadding sx={{ justifyContent: 'center' }}>
                      <ListItemButton
                        className={classes.shareAndDownloadMobileButton}
                        sx={{ flexGrow: 0 }}
                        onClick={() => {
                          const link = document.createElement("a");
                          // link.href = fileURL;
                          link.href = `${window.location.pathname}${PDF_NAME_HR}`;
                          link.download = 'LUCIOLE-RA-2026.pdf';
                          link.click();
                          if (window.umami) {
                            window.umami.track(`Portfolio RA - Download`);
                          }
                        }}
                      >
                        <ListItemIcon>
                          <img className={classes.menuIcon} src={DownloadIconUrl} alt={DOWNLOAD_TEXT} />
                        </ListItemIcon>
                        <ListItemText className={classes.drawerLabel} primary={<Typography variant="h4">{DOWNLOAD_TEXT}</Typography>} />
                      </ListItemButton>
                    </ListItem>
                  </Stack>

              </>
            )}
          </Paper>
        </SwipeableDrawer>
        <Stack className={classes.mobileMenuFooterContent} direction="row" alignItems="flex-end" justifyContent="space-evenly" spacing={2}>
          {MENU_HIERARCHY_MOBILE.map(item => {
            const isFocus = page >= item.pages[0] && page <= item.pages[1];
            const isMenuOpen = swipeMenuOpen && item === currentHighlightedItem;
            return (
              <div key={item.label} className={`${classes.mobileMenuButtonWrapper} ${isFocus ? 'focus' : ''} ${item.color}`}>
                <Button
                  className={`${classes.mobileMenuButton} ${isMenuOpen ? 'menuOpen' : ''} ${isFocus ? 'focus' : ''} ${item.color}`}
                  size="small"
                  onClick={() =>
                    this.setState(prevState => ({
                      currentHighlightedItem: item,
                      swipeMenuOpen:
                        prevState.currentHighlightedItem === item
                          ? !prevState.swipeMenuOpen
                          : true
                    }))
                  }
                >
                  <Typography variant="h2" >{item.label}</Typography>
                </Button>
              </div>
            );
          })}
        </Stack>
      </div>
    );
  }

  render() {
    return (
      <>
        {this.renderHeader()}
        {this.renderFooter()}
      </>
    );
  }
}

MobileAppMenu.propTypes = {
  // props
  categoryOpen: PropTypes.string,
  // funcs
  onNavigate: PropTypes.func.isRequired,
  onToggleFullscreen: PropTypes.func.isRequired,
  onZoom: PropTypes.func.isRequired,
}

export default withStyles(styles)(MobileAppMenu);
